export enum ProductTypeEnum {
  FIXED = 'FIXED',
  DISCOUNT = 'DISCOUNT',
  TRACKER = 'TRACKER',
}
